import './polyfill';
import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';
import pageResponse from './assets/js/pageResponse';
import Modal from 'react-modal';
import createAppStore from './store';

function pageResize() {
  pageResponse({
    selectors: '#root',
    mode: 'auto',
    width: '750',
    height: '1334'
  });
}

window.onload = pageResize;
window.onresize = pageResize;

const render = () => {
  // use async render to avoid output to screen before pageResize
  // eslint-disable-next-line prefer-arrow-callback
  setTimeout(function _entrypoint() {
    const { store, history } = createAppStore();

    const rootElement = document.getElementById('root');
    Modal.setAppElement(rootElement);
    window.document.getElementById('loading').remove();
    ReactDOM.render(<App store={store} history={history} />, rootElement);
  }, 1);
};

(function main() {
  render();
}());

// registerServiceWorker();



// WEBPACK FOOTER //
// ./src/index.js